var exports = {
  "l": "Trigger__M60S2y",
  "w": "Number__q-J63b",
};

module.exports = exports;
